import React from 'react';
import { Paperclip } from 'lucide-react';

// Every receipt on a row — not just the first.
//
// A claim can carry several documents (a cab bill plus its GST invoice, a
// multi-page scan). For a long time every view rendered `attachments[0]` and
// nothing else, so the rest were stored and POSTed but unreachable anywhere in
// the UI: finance could only get at them through the bulk zip on the
// Reimbursements page. This renders the lot.
export default function AttachmentLinks({
  attachments = [],
  emptyLabel = 'No proof attached',
  className = '',
}) {
  const files = (attachments || []).filter((file) => file && file.dataUrl);
  if (!files.length) {
    return <span className="text-slate-400 italic text-xs">{emptyLabel}</span>;
  }

  return (
    <div className={`flex flex-col gap-1 min-w-0 ${className}`}>
      {files.length > 1 && (
        <span className="text-[10px] font-bold uppercase tracking-wider text-slate-400">
          {files.length} files
        </span>
      )}
      {files.map((file, i) => (
        <a
          key={file.id || `${file.name}-${i}`}
          href={file.dataUrl}
          download={file.name || `receipt-${i + 1}`}
          title={file.name || `Receipt ${i + 1}`}
          className="inline-flex items-center gap-1.5 text-xs text-indigo-600 hover:text-indigo-900 hover:underline font-semibold min-w-0 max-w-[220px]"
        >
          <Paperclip size={12} className="shrink-0" />
          <span className="truncate">{file.name || `Receipt ${i + 1}`}</span>
        </a>
      ))}
    </div>
  );
}
